import * as types from './mutation-types'

export const mutations = {
  [types.INIT_HOME] (state, o) {
    state.recommend = o.recommend
    state.section = o.section
  },
  [types.INIT_BUSINESS] (state, o) {
    state.data = o
  }  ,
  [types.INIT_NOTICE] (state, o) {
    state.notice = o
  }  
}



// WEBPACK FOOTER //
// ./src/logic/home/mutations.js